export default __webpack_public_path__ + "static/media/dust_bowl.1ec6a8ef.jpg";